import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { catchError, retry } from "rxjs/operators";
import { ITicket } from "../shared/models/ticket.model";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";
import { Utilities } from "./utilities";

@Injectable()
export class TicketProvider {

  private action: string = "update";

  constructor(
    private http: HttpClient,
    private utilities: Utilities,
    private historyData: HistoryData,
    private afDb: AngularFireDatabase,
    private tracking: TrackingProvider,
  ) { }

  public getTicketList(clientId: string): Observable<ITicket[]> {
    return this.afDb.list<ITicket>(`Clients/${clientId}/Ticket`).valueChanges();
  }

  public getTicketById(clientId: string, ticketId: string): Observable<ITicket> {
    return this.afDb.object<ITicket>(`Clients/${clientId}/Ticket/${ticketId}`).valueChanges();
  }

  public createOrUpdate(client: string, object: ITicket, id: string = "") {
    if (!id) {
      id = this.afDb.createPushId();
      this.action = "create";
      object.created_at = new Date().getTime();
    } else {
      this.action = "update";
      object.update_at = new Date().getTime();
    }

    object.id = id;
    return new Promise((res, rej) => {
      this.afDb.database
        .ref(`Clients/${client}/Ticket/${id}/`)
        .update(object)
        .then(() => {
          return this.historyData.set(
            `Ticket content`,
            "ticket",
            this.action,
            object,
          );
        })
        .then(() => {
          this.tracking.trackEntity(_TRACKING_ENTITIES.TICKET, id, client, object);
          return res();
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }

  public generateSingleReport(clientId: string, ticketId: string): Promise<any> {
    return this.http.get(`${ENV.backend}/ticketSingle/${clientId}/${ticketId}`)
      .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error generate report: ", err, "red")]))
      .toPromise();
  }

  public generateGeneralReport(clientId: string): Promise<any> {
    return this.http.get(`${ENV.backend}/reports/tickets/${clientId}`)
      .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error generate report: ", err, "red")]))
      .toPromise();
  }

  public getPlacesTicket(client: string): Observable<any[]> {
    return this.afDb.list(`Clients/${client}/PlacesTicket`).valueChanges();
  }

  public createOrUpdatePlaceTicket(client: string, place: any) {
    if (place.id === "") {
      this.action = "create";
      place.id = this.afDb.createPushId();
      place.created_at = new Date().getTime();
    } else {
      this.action = "update";
      place.update_at = new Date().getTime();
    }
    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${client}/PlacesTicket/${place.id}`)
        .update(place)
        .then(() => {
          return this.historyData.set(
            `Staff category content`,
            "staff",
            this.action,
            place,
          );
        })
        .then(() => {
          resolve(place);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/ticket.ts